import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '../Layout';
import 'bootstrap/dist/css/bootstrap.min.css';
import ClientsTable from './ClientsTable';
import CoachesTable from './CoachesTable';
import RecycleBinTable from './RecycleBinTable';
import AssignLogsTable from './AssignLogsTable';
import UnassignedTable from './UnassignedTable';
import { fetchClients, exportClients, createClient, updateClient, clearMessages } from '../../../redux/slices/admin/clientsSlice';

import { fetchUnassignedClients } from '../../../redux/slices/admin/unassignedSlice';


import { fetchCoaches, createCoach, updateCoach, clearMessagesCoach} from '../../../redux/slices/admin/coachesSlice';
import { fetchRecycleBin, restoreUser } from '../../../redux/slices/admin/recycleBinSlice';
import { fetchCoachesMin } from '../../../redux/slices/optionsSlice';
import UserDetailModal from './UserDetailModal';
import iconPrinter from '../../../images/icon-printer.svg';
import iconDownload from '../../../images/icon-download.svg';
import iconPlus from '../../../images/icon-plus-symbol.svg';
import api from '../../../api';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import SearchField from '../../../components/common/SearchField';
import ProgramListModal from './ProgramListModal';
import { getProgramListMinimal } from '../../../redux/slices/admin/clientsSlice';
import showAlert from '../../../components/common/showAlert'; 

const Users = () => {
  const [activeTab, setActiveTab] = useState('clients');
  const dispatch = useDispatch();
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserD, setSelectedUserD] = useState(null);
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isProgramListModalOpen, setIsProgramListModalOpen] = useState(false);
  const [activeCoach, setActiveCoach] = useState('');
  const [filterUserType, setFilterUserType] = useState('');
  
  //isEditMode

  const generateRandomPassword = (length = 14) => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let password = "";
    for (let i = 0; i < length; i++) {
      password += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return password;
  };

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    password: !isEditMode ? generateRandomPassword() : '',
    address: '',
    account_type: 'client'
  });

  const { user_super_admin  } = useSelector((state) => state.protect);
 
  // Select messages from state
  const successMessage = useSelector(state => activeTab === 'clients' ? state.admin_clients.successMessage : state.admin_coaches.successMessage);
  const errorMessage = useSelector(state => activeTab === 'clients' ? state.admin_clients.errorMessage : state.admin_coaches.errorMessage);
  const coaches_min = useSelector((state) => state.app_options?.coaches_min);


 useEffect(() => {
    if (successMessage && successMessage != '') {
      setIsCreateModalVisible(false);      
      showAlert('success', successMessage);
      dispatch(clearMessages());
      dispatch(clearMessagesCoach());
    }
  }, [successMessage]);

  useEffect(() => {
    dispatch(fetchClients({ page: 1, account_type: 'client', searchTerm:'', activeCoach:activeCoach, user_type:filterUserType }));
    dispatch(fetchCoaches(1));
    dispatch(fetchRecycleBin(1));
    dispatch(fetchUnassignedClients({ page: 1}));
  }, [dispatch]);

  const handleTabChange = (tab) => {

    if (activeTab == 'coaches') {
      dispatch(fetchCoachesMin());
    } 

    var search_field_value = document.getElementById('searchField').value;
    if (search_field_value.length>0) {
      if (activeTab == 'clients') {
        dispatch(fetchClients({ page: 1, account_type: 'client' }));
      }
      if (activeTab == 'coaches') {
        dispatch(fetchCoaches(1));
      }
      if (activeTab == 'recycle Bin') {
        dispatch(fetchRecycleBin(1));
      }
      if (activeTab == 'unassigned') {
        dispatch(fetchUnassignedClients({ page: 1 }));
      }
    }
    setActiveTab(tab);
  };

  const openEditModal = (user) => {
    dispatch(clearMessages());
    setSelectedUser(user);
    setFormData(user);
    setIsEditMode(true);
    setIsCreateModalVisible(true);
  };

  const handleRestoreUser = (userId) => {
    confirmAlert({
      title: 'Confirm Restore',
      message: 'Are you sure you want to restore this user?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => restore(userId)
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });    
  };

  const restore = (userId) => {
    dispatch(restoreUser(userId))
      .unwrap()
      .then((restoredUser) => {
        dispatch(fetchClients({ page: 1, account_type: 'client' }));
        dispatch(fetchCoaches(1));
        dispatch(fetchCoachesMin());
        dispatch(fetchUnassignedClients({ page: 1}));
      })
      .catch((error) => {
        console.error('Failed to restore user:', error);
      });
  }

  const handleUserSelect = async (userId) => {
    try {
      const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/admin/users/${userId}`);
      if (response.data.success) { 
        setSelectedUserD(response.data.data);
      } else {
        console.error('Failed to fetch user details:', response.data.message);
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };

  const closeModal = () => {
    setSelectedUser(null);
    setSelectedUserD(null);
    setFormData({
      first_name: '',
      last_name: '',
      email: '',
      password: !isEditMode ? generateRandomPassword() : '',
      address: '',
      account_type: 'client'
    });
    setIsCreateModalVisible(false);
    setIsEditMode(false);
    dispatch(clearMessages());
    dispatch(clearMessagesCoach());
  };

  const openCreateModal = () => {
    setFormData({
      first_name: '',
      last_name: '',
      email: '',
      password: !isEditMode ? generateRandomPassword() : '',
      address: '',
      account_type: activeTab == 'clients' ? 'client' : 'admin'
    })
    setIsCreateModalVisible(true);
    setIsEditMode(false);
    dispatch(clearMessages()); 
    dispatch(clearMessagesCoach());
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(clearMessages());
    dispatch(clearMessagesCoach()); 
    try {
      if (isEditMode) {
        if (activeTab == 'clients') {
            await dispatch(updateClient({ id: selectedUser.id, ...formData }));
        } else {
            await dispatch(updateCoach({ id: selectedUser.id, ...formData }));
        }        
      } else {
        if (activeTab == 'clients') {
            await dispatch(createClient(formData));
        } else {
            await dispatch(createCoach(formData));
        }
      }
    } catch (error) {
      console.error('Submission error:', error);
    }
  };
 
  const handleSearch = (searchTerm, activeTab) => {
    if (activeTab == 'clients') {
      dispatch(fetchClients({ page: 1, account_type: 'client', searchTerm:searchTerm, activeCoach:activeCoach, user_type:filterUserType }));
    }
    if (activeTab == 'coaches') {
      dispatch(fetchCoaches({ page: 1, account_type: 'admin', searchTerm:searchTerm, activeCoach:activeCoach, user_type:filterUserType }));
    }
    if (activeTab == 'recycle Bin') {
      dispatch(fetchRecycleBin({page:1, account_type:'', type:'deleted_users', searchTerm:searchTerm, activeCoach:activeCoach, user_type:filterUserType}));
    }
    if (activeTab == 'unassigned') {
      dispatch(fetchUnassignedClients({page:1, account_type:'unassigned', searchTerm:searchTerm, activeCoach:activeCoach, user_type:filterUserType}));
    }
  }

  const handlePageChangeFunc = (page, activeTab) => {
    var searchField = document.getElementById('searchField').value;
    if (activeTab == 'clients') {
      dispatch(fetchClients({ page: page, account_type: 'client', searchTerm:searchField, activeCoach:activeCoach, user_type:filterUserType }));
    }
    if (activeTab == 'coaches') {
      dispatch(fetchCoaches({ page: page, account_type: 'admin', searchTerm:searchField, activeCoach:activeCoach, user_type:filterUserType }));
    }
    if (activeTab == 'recycle Bin') {
      dispatch(fetchRecycleBin({page:page, account_type:'', type:'deleted_users', searchTerm:searchField, activeCoach:activeCoach, user_type:filterUserType}));
    } 
    if (activeTab == 'unassigned') {
      dispatch(fetchUnassignedClients({page:page}));
    }
  }


  const handlePrint = () => { window.print(); };

  const handleDownloadExcel = (type) => { dispatch(exportClients(type)); };

  const openProgramListModal = (user) => {
    setSelectedUser(user);
    dispatch(getProgramListMinimal());  
    setIsProgramListModalOpen(true);
  }

  const handleCloseProgramListModal = () => {
    setIsProgramListModalOpen(false);
  }

  useEffect(() => {
    dispatch(fetchCoachesMin());
  }, []);

  const handleCoachChange = (coachId) => {
    setActiveCoach(coachId);
    dispatch(fetchClients({ page: 1, account_type: 'client', searchTerm:'', activeCoach:coachId, user_type:filterUserType }));
  }

  const handleFilterUserTypeChange = (user_type) => {
    setFilterUserType(user_type);
    dispatch(fetchClients({ page: 1, account_type: 'client', searchTerm:'', activeCoach:activeCoach, user_type:user_type }));
  }

  return (
    <Layout>
      <div className="container-xxl">
        <div className="row mx-0 p-3 g-3 p-md-4 nav-users-tab">
          <div className="col-md-12">
            <h1 className="title-page">Users</h1>
          </div>
          <div className="col">
            <ul className="nav nav-pills">
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === 'clients' ? 'active' : ''}`}
                  onClick={() => handleTabChange('clients')}>
                  Clients
                </a>
              </li>
              {user_super_admin === '1' && (
                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === 'coaches' ? 'active' : ''}`}
                    onClick={() => handleTabChange('coaches')}>
                    Coaches
                  </a>
                </li>
              )}
              
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === 'recycle Bin' ? 'active' : ''}`}
                  onClick={() => handleTabChange('recycle Bin')}>
                  Recycle Bin
                </a>
              </li>

              {user_super_admin === '1' && (
                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === 'unassigned' ? 'active' : ''}`}
                    onClick={() => handleTabChange('unassigned')}>
                    Unassigned Clients
                  </a>
                </li>
              )}

            </ul>
          </div>
          <div className="col-12 mt-4">
            <div className="tab-content" id="pills-tabContent">
              {activeTab === 'clients' && (
                <div className="tab-pane active">
                  <ul className="ul-btns-action">
                    <li>
                      <a>
                        <img src={iconPrinter} alt="Print" onClick={handlePrint} />
                      </a>
                    </li>
                    <li>
                      <a onClick={()=>handleDownloadExcel('clients')}>
                        <img src={iconDownload} alt="Download" />
                      </a>
                    </li>
                    <li>
                      <a onClick={openCreateModal} className="add-plus-icon">
                        <img src={iconPlus} alt="Add" />
                      </a>
                    </li>
                  </ul>
                  <SearchField handleSearch={handleSearch} activeTab={activeTab} placeholder="Search Clients..." />

                  <div className="row">
                  <div className="col-6">
                  <select
                    className="form-control"
                    value={activeCoach || ''}
                    onChange={(e) => handleCoachChange(e.target.value)}
                    style={{marginBottom:'10px'}}
                  >
                    <option value="">Filter By Coach</option>
                    {coaches_min && coaches_min.map((coach) => (
                      <option key={coach.id} value={coach.id}>
                        {coach.first_name} {coach.last_name}
                      </option>
                    ))}
                  </select>
                  </div>

                  <div className="col-6">
                  <select
                    className="form-control"
                    value={filterUserType || ''}
                    onChange={(e) => handleFilterUserTypeChange(e.target.value)}
                    style={{marginBottom:'10px'}}
                  >
                      <option value="">Filter By User Type</option>
                      <option value='1'>1-1 Premium</option>
                      <option value='2'>Academy Clients</option>                     
                  </select>
                  </div>
                  </div>

                  <ClientsTable handlePageChange={(page) => handlePageChangeFunc(page, 'clients')} onUserSelect={handleUserSelect} openEditModal={openEditModal} openProgramListModal={openProgramListModal} />
                </div>
              )}
              {activeTab === 'coaches' && user_super_admin == '1' && (
                <div className="tab-pane active">
                 <ul className="ul-btns-action">
                    <li>
                      <a>
                        <img src={iconPrinter} alt="Print" onClick={handlePrint} />
                      </a>
                    </li>
                    <li>
                      <a onClick={()=>handleDownloadExcel('coaches')}>
                        <img src={iconDownload} alt="Download" />
                      </a>
                    </li>
                    <li>
                      <a onClick={openCreateModal} className="add-plus-icon">
                        <img src={iconPlus} alt="Add" />
                      </a>
                    </li>
                  </ul>

                  <SearchField handleSearch={handleSearch} activeTab={activeTab} placeholder="Search Coaches..." />

                  <CoachesTable handlePageChange={(page) => handlePageChangeFunc(page, 'coaches')} openEditModal={openEditModal} />
                </div>
              )}

              {activeTab === 'recycle Bin' && (
                <div className="tab-pane active">

                  <ul className="ul-btns-action">
                    <li>
                      <a>
                        <img src={iconPrinter} alt="Print" onClick={handlePrint} />
                      </a>
                    </li>
                    <li>
                      <a onClick={()=>handleDownloadExcel('recyclebin')}>
                        <img src={iconDownload} alt="Download" />
                      </a>
                    </li>
                  </ul>

                  <SearchField handleSearch={handleSearch} activeTab={activeTab} placeholder="Search Deleted Clients..."  />
                  <RecycleBinTable handlePageChange={(page) => handlePageChangeFunc(page, 'recycle Bin')} handleRestore={handleRestoreUser} onUserSelect={handleUserSelect} />
                </div>
              )}

              {activeTab == 'unassigned' && (
                <div className="tab-pane active">
                  <SearchField handleSearch={handleSearch} activeTab={activeTab} placeholder="Search..." />

                  <UnassignedTable handlePageChange={(page) => handlePageChangeFunc(page, 'unassigned')} onUserSelect={handleUserSelect} openEditModal={openEditModal} openProgramListModal={openProgramListModal} />
                </div>
              )}



              {activeTab === 'logs' && (
                <div className="tab-pane active">
                  <AssignLogsTable handlePageChange={(page) => handlePageChangeFunc(page, 'clients')} onUserSelect={handleUserSelect} openEditModal={openEditModal} openProgramListModal={openProgramListModal} />
                </div>
              )}





            </div>
          </div>
        </div>

{selectedUserD && <UserDetailModal user={selectedUserD} onClose={closeModal} />}

{isCreateModalVisible && (isEditMode || !isEditMode) && (
  <div className="modal fade show d-block" id="createBackdrop" tabIndex="-1" aria-labelledby="createBackdropLabel" aria-hidden="true" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
    <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-create">
      <div className="modal-content">
        <div className="modal-header justify-content-center">
          <h1 className="modal-title" id="createBackdropLabel">
            {isEditMode ? `Edit ${activeTab === 'clients' ? 'Client' : 'Coach'}` : `Create ${activeTab === 'clients' ? 'Client' : 'Coach'}`}
          </h1>
          <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
        </div>
        <div className="modal-body px-md-5 pb-md-4">
          <form onSubmit={handleSubmit}>
            <div className="row g-3 gx-md-5 gy-md-4">
              <div className="col-md-6">
                <input
                  type="text"
                  placeholder="First Name"
                  className="form-control form-control-lg"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleFormChange}
                  required
                />
              </div>
              <div className="col-md-6">
                <input
                  type="text"
                  placeholder="Last Name"
                  className="form-control form-control-lg"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleFormChange}
                  required
                />
              </div>
              <div className="col-md-6">
                <input
                  type="email"
                  placeholder="Email"
                  autocomplete="email"
                  className="form-control form-control-lg"
                  name="email"
                  autoComplete="off"
                  value={formData.email}
                  onChange={handleFormChange}
                  required
                />
              </div>
              <div className="col-md-6">
                <input
                  type="text"
                  placeholder="Password"
                  autocomplete="new-password"
                  className="form-control form-control-lg"
                  name="password"
                  value={formData.password}
                  onChange={handleFormChange}
                  required={!isEditMode}
                />
              </div>
            </div>
            <div className="mt-4">
              <button type="submit" className="btn btn-create w-100">
                {isEditMode ? `Update ${activeTab === 'clients' ? '' : ''}` : `Create ${activeTab === 'clients' ? '' : ''}`}
              </button>
            </div>
            {errorMessage && <div className="alert alert-danger mt-3">{errorMessage}</div>}
          </form>
        </div>
      </div>
    </div>
  </div>
)}
      </div>

      <ProgramListModal isOpen={isProgramListModalOpen} onClose={handleCloseProgramListModal} selectedUser={selectedUser} /> 
    </Layout>
  );
};

export default Users;